import React, { FC } from 'react';
import useNativeChangeTitle from 'SRC/common/hooks/useNativeChangeTitle';
import styles from '../../../assets/styles.scss';
interface IBaseProps {}
const PrivacyPolicies: FC<IBaseProps> = () => {
  useNativeChangeTitle('纳米盒隐私政策', '');
  return (
    <div className={styles['policies-wrap']}>
      <h1>纳米盒隐私政策</h1>
      <p>
        首次发布时间：2014年9月1号
        <br />
        最新更新时间：2024年12月31号
        <br />
      </p>
      <br />
      <p>提示条款：</p>
      <p style={{ textIndent: '2em' }}>
        您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴此，
        <strong>上海进馨网络科技有限公司</strong>
        （或以下简称“我们”或“进馨科技”）制定本《纳米盒隐私政策》（以下简称“本政策”或“本隐私政策”）。
      </p>
      <p style={{ textIndent: '2em' }}>
        本政策适用于<strong>进馨科技旗下的纳米盒产品与/或服务</strong>
        ，本政策不适用于其他第三方向您提供的服务，纳米盒上的其他卖家依托平台向您提供服务时，您向卖家提供的个人信息不适用本政策。
      </p>
      <p style={{ textIndent: '2em' }}>
        <strong>
          本政策与您使用我们的服务关系紧密，我们建议您仔细阅读并理解本政策全部内容，做出您认为适当的选择。我们努力用通俗易懂、简明扼要的文字表达，并对本政策中与您的权益存在重大关系的条款，采用
          <strong>粗体字进行标注</strong>以提示您注意。
        </strong>{' '}
      </p>
      <h3>1、我们如何收集、使用信息</h3>
      <p style={{ textIndent: '2em' }}>
        我们会在向你提供服务过程中使用你主动提供的，以及经过你的授权通过自动化手段收集的下列信息：
      </p>
      {/* panel */}
      <section className={styles['panel']}>
        <h5>1.1 个人基本资料</h5>
        <p>
          <strong>概要：</strong>我们需要您在注册时输入<strong>手机号</strong>。
        </p>
        <p>
          <strong>使用目的：</strong>
          进行账户注册，并用于今后的<strong>登录</strong>
          认证，我们可能通过手机号码向您发送运营、推广、活动等信息，您可以拒绝或退订我们或运营方发送的上述信息。
        </p>
      </section>
      {/* panel */}
      <section className={styles['panel']}>
        <h5>1.2 网络身份标识信息</h5>
        <p>
          <strong>概要：</strong>
          您在注册用户时我们可能通过由您输入（以下选填部分）收集您的以下个人信息：
          <strong>
            省份城市（选填）、年级（选填）、昵称（选填，将公开）、用户上传头像（选填，将公开）
          </strong>
          。
        </p>
        <p>
          <strong>使用目的：</strong>
          用于筛选对应年级的书本，不同地方区域出版社书本。
        </p>
        <p>
          <strong>概要：</strong>
          您在注册用户时，我们通过系统采集方式收集您的以下个人信息： 注册时的
          <strong>IP地址和源端口</strong>
          （公安要求）、若用微信登录的，收集用微信联合登录相关的：
          <strong>openid和unionid、微信昵称、头像。</strong>
        </p>
        <p>
          <strong>使用目的：</strong>
          使用支付魔法课本等交易功能。
        </p>
      </section>
      {/* panel */}
      <section className={styles['panel']}>
        <h5>1.3 个人常用设备信息</h5>
        <p>
          <strong>概要：</strong>
          设备信息(
          <strong>
            设备型号、应用进程列表、设备识别码、设备序列号、操作系统及软件版本、设备状态、网络状况，已安装APP信息或运行中的进程信息
          </strong>
          )，包括设备识别码（
          <strong>
            IMEI、IDFA、Android
            ID、MAC地址、SSID、BSSID、OAID、IMSI、GUID、SIM卡序列号
          </strong>
          及其他设备相关信息），设备信息在手机终端中可能被表述为“电话信息”，这不代表App会收集通讯内容或您主动输入的隐私信息。我们会在您首次使用APP并同意本隐私政策之后，在前台运行或静默状态下或在后台运行时通过系统采集您的以上个人常用设备信息。（此个人信息由友盟SDK收集使用）
        </p>
        <p>
          <strong>使用目的：</strong>
          设备标识信息对于用户绑定设备号的统计具有不可替代的作用。设备信息也通常用在反作弊和判断账号是否处理安全环境中，例如：微信或支付宝支付时判断支付环境是否安全。
        </p>
      </section>
      {/* panel */}
      <section className={styles['panel']}>
        <h5>1.4 个人财产信息（交易订单信息）</h5>
        <p>
          <strong>概要：</strong>
          包括购买商品（课本ID）、
          <strong>支付时间、支付价格、订单号、用户ID（Md5加密）</strong>例如:
          ZXQ5G20251LN6R00）、<strong>支付方式</strong>
          （如支付宝、微信、银联等）及<strong>交易流水号</strong>
          。我们会在您下单成功时通过系统采集方式收集以上个人信息。
        </p>
        <p>
          <strong>使用目的：</strong>
          方便用户查询或退订订单使用，合作方明确订单数量（不提供合作方支付方式及交易流水号）。
        </p>
        <p>
          <strong>特别说明：</strong>
          合作方无法通过订单信息识别您本人的身份。
        </p>
        <p>
          <br />
          <strong>概要：</strong>
          您在售卖实物商品活动中输入<strong>收货地址</strong>信息。
        </p>
        <p>
          <strong>使用目的：</strong>
          在售卖实物商品活动中，公司会按照收货地址邮寄货物，因此会记录地址信息（仅仅涉及购买实物商品的注册用户）。
        </p>
        <p>
          <br />
          <strong>概要：</strong>
          您使用盒币购买商品或服务时系统采集您的<strong>盒币</strong>
          （纳米盒虚拟币）信息（盒币数量）。
        </p>
        <p>
          <strong>使用目的：</strong>
          用来支付实物商品或虚拟服务。
        </p>
        <p>
          <br />
          <strong>概要：</strong>
          您在消耗金币时，系统采集您的<strong>金币</strong>
          信息（金币数量、时间）。
        </p>
        <p>
          <strong>使用目的：</strong>
          在鱼塘兑换鱼食、喂养小鱼，鼓励用户使用APP行为的激励措施。
        </p>
      </section>
      {/* panel */}
      <section className={styles['panel']}>
        <h5>1.5 个人上网记录</h5>
        <p>
          <strong>概要：</strong>
          您在纳米盒APP产生以下行为时，系统采集您的以下行为数据：用户发帖和评论信息：注册用户发表的
          <strong>
            帖子信息或对帖子进行评论、点赞和转发(将公开);阅读的书目、阅读时长、练习时长、学习数据
          </strong>
          。
        </p>
        <p>
          <strong>使用目的：</strong>
          分析您使用我们服务的情况，用于改善纳米盒APP内容。
        </p>
        <p>
          <br />
          <strong>概要：</strong>
          您在使用口语评测功能时，打开麦克风权限，系统会收集您的
          <strong>评测结果音频</strong>（含口语评测音频信息及系统打分）。
        </p>
        <p>
          <strong>使用目的：</strong>
          便于您回听自己的读音，并和标准音进行比对，利于纠音。
        </p>
        <p>
          <br />
          <strong>概要：</strong>
          您在使用班级圈功能时，我们收集在您加入班级圈时选择的
          <strong>学校班级</strong>这些个人信息。
        </p>
        <p>
          <strong>使用目的：</strong>
          便于您和同班同学一起学习PK，激励使用纳米盒APP。
        </p>

        <p>
          <br />
          <strong>
            注意：以上个人上网记录的用户行为若属于14周岁以下未成年的信息，是敏感个人信息，如不满14岁未成年人的语音测评信息、班级圈信息（所属学校、班级等），一旦泄露或者非法使用，容易导致你的人格尊严受到侵害或者人身、财产安全受到危害。我们在此征求你和你的监护人的同意，并按本隐私政策《6、未成年人个人信息保护》执行。
          </strong>
        </p>
      </section>
      <h3>2、如何更好地控制个人信息的使用</h3>
      {/* panel */}
      <section className={styles['panel']}>
        <h5>隐私权限撤销</h5>
        <p>
          <strong>概要：</strong>
          您可前往隐私权限设置界面
          <strong>（账户/未登录-设置（右上角设置按钮）-隐私权限设置）</strong>
          ，开启或撤销对应权限访问
        </p>
        <p>
          <strong>特别说明：</strong>
          关闭以下权限后涉及对应权限的功能可能会产生影响或不能正常使用，例如关闭麦克风权限后，您将无法进行语音评测。
        </p>

        <p>
          <br />
          <strong>相机权限</strong>
          <br />
          在您使用拍照、上传作品时申请。
        </p>
        <p>
          <strong>使用目的：</strong>用以上传作品、显示自己的头像。
        </p>
        <p>
          <br />
          <strong>相册权限</strong>
          <br />
          在您上传作品时、保存图片时申请。
        </p>
        <p>
          <strong>使用目的：</strong>用以上传作品、保存图片到本地相册。
        </p>
        <p>
          <br />
          <strong>位置权限</strong>
          <br />
          选择地区、填写学习信息时申请。
        </p>
        <p>
          <strong>使用目的：</strong>
          根据地域筛选课本信息。
        </p>
        <p>
          <br />
          <strong>麦克风权限</strong>
          <br />
          麦克风为敏感权限，在您使用语音评测、绘本配音时申请;。
        </p>
        <p>
          <strong>使用目的：</strong>用于语音评测时为您进行AI评分。
        </p>
        <p>
          <strong>特别说明：</strong>
          我们不会私自开启麦克风窃取您的隐私，更不会采用此种非法手段进行信息、广告推送。
        </p>
        <p>
          <br />
          <strong>通知权限</strong>
          <br />
          App启动时申请。
        </p>
        <p>
          <strong>使用目的：</strong>
          用以推送订单信息，学习营开营提醒，学习状态等信息。
        </p>
        <p>
          <br />
          <strong>存储权限</strong>
          <br />
          存储空间权限是指提供写入外部存储功能，允许写入、读取、删除存储空间及相片的权限；保存图片或下载书本时申请。
        </p>
        <p>
          <strong>使用目的：</strong>
          用于将图片保存到系统相册，用于书本下载到磁盘空间。
        </p>
        <p>
          <br />
          <strong>设备重力、陀螺仪、加速度等传感器信息</strong>
          <br />
          调用设备的陀螺仪、加速度、重力传感器以识别判断您当前设备的屏幕朝向，自动布局当前页面展示，为用户提供更好的横竖屏使用体验。
        </p>
        <p>
          <strong>使用目的：</strong>
          在阅读书本时，检测设备屏幕方向变化，用于横竖屏布局显示，以便为用户提供更加合适的阅读体验。
        </p>

        <p>
          <br />
          <strong>应用自启动</strong>
          <br />
          <strong>概要：</strong>
          应用自启动指app在应用退出后用户不主动点击启动App的情况下应用自动启动。
        </p>
        <p>
          <strong>使用目的：</strong>
          用户在课本内点击《定时播放》功能，选择课本章节和定时播放的时间，app将在用户指定的时间启动并播放课本音频内容。
        </p>
        <p>
          <strong>特别说明：</strong>
          app定时播放功能仅在用户开启并设定了定时时间才会生效，在没有开启定时播放功能时，app不会自启动。
        </p>
        <p>
          <strong>涉及模块：</strong>
          com.evernote.android.job
        </p>
      </section>
      {/* panel */}
      <section className={styles['panel']}>
        <h5>账号注销</h5>
        <p>
          <strong>概要：</strong>
          如您已注册登录，可前往注销账号界面
          <strong>（账户/未登录-设置（右上角设置按钮）-系统设置-注销）</strong>
          ，向客服申请注销账号。一旦注销账号，我们将在3个工作日内删除我们根据本隐私政策
          <strong>《1、我们如何收集、使用信息》</strong>
          收集到的您的所有个人信息。
        </p>
        <p>
          <strong>
            特别说明：
            账号注销前请确保您的账号已经清空（包括红包、金币、优惠券等），一旦注销您的账号信息及该账号信息产生的数据将被删除且不可恢复。
          </strong>
        </p>
      </section>
      <h3>
        3、纳米盒App涉及嵌入第三方代码、插件传输个人信息的情形逐项列举，详见：
        <br />
        <a href="/privacy-compliance/#/third-sharing-checklist">
          第三方信息共享清单
        </a>
      </h3>
      <br />
      <h3>4、我们如何使用Cookies和同类技术</h3>
      {/* panel */}
      <section className={styles['panel']}>
        <p style={{ textIndent: '2em' }}>
          我们会通过<strong>cookies和web beacon</strong>
          收集和使用您的信息，我们使用自己的cookies和web
          beacon。目的的是为了向您提供更好的服务，主要用于以下用途：
        </p>
        <p>
          1、记住您的身份。例如：cookies和web
          beacon有助于我们辨认您作为注册用户的身份是否是新设备的信息。
          <br />
          2、分析您使用我们服务的情况。例如：利用cookies和web
          beacon来存储您选择的年级，地区，这些信息仅当做app内信息的共享方式。
        </p>
      </section>
      <h3>5、个人信息的保存</h3>
      <section className={styles['panel']}>
        <p>
          1、您的个人信息数据将
          <strong>存储在中华人民共和国境内，不存在出境行为。</strong>
          <br />
          2、在您使用我们的产品与/或服务期间，您的个人信息将在为了实现本政策所述目的之期限内保存，同时将结合法律有强制的留存要求期限的规定确定，如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。在超出保存期间后，我们会根据适用法律的要求删除您的个人信息，或进行匿名化处理。
          <br />
          3、如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。
        </p>
      </section>
      <h3>6、未成年人个人信息保护</h3>
      <section className={styles['panel']}>
        <p style={{ textIndent: '2em' }}>
          我们的产品、网站和服务主要面向未成人。但如果没有父母或监护人的同意，儿童不应创建自己的用户账户。
        </p>
        <p style={{ textIndent: '2em' }}>
          对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
        </p>
        <p style={{ textIndent: '2em' }}>
          尽管当地法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。
        </p>
        <p style={{ textIndent: '2em' }}>
          如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
        </p>
        <p style={{ textIndent: '2em' }}>
          对于可能涉及的不满14周岁的儿童个人信息，我们进一步采取以下措施予以保障：
          <br />
          1、对于收集到的儿童的个人信息，我们除遵守本隐私政策关于用户个人信息保护的约定外，还会切实按照《儿童个人信息网络保护规定》的要求，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则。
          <br />
          2、我们严格遵循《网络安全法》、《中华人民共和国未成年人保护法》、《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露收集到的儿童个人信息，且不会超过实现收集、使用目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。
          <br />
          3、当您作为监护人为被监护的儿童选择我们的相关服务时，我们可能需要向您收集被监护儿童的个人信息，用于向您履行相关服务之必要。在具体的服务中需要向您收集儿童个人信息的，我们会事先取得您的授权同意，并告知您收集的目的和用途。如果您不提供前述信息，您将无法享受我们提供的相关服务。此外，您在选择使用年级、学校等功能时，可能会主动向我们提供儿童的个人信息，请您明确知悉并谨慎选择。您作为监护人应当正确履行监护职责，保护儿童个人信息安全。若儿童本人需要注册或使用我们的产品或服务，您应当正确引导并予以监护。
          <br />
          4、儿童或者监护人有权访问、更正、删除儿童个人信息。如您对儿童个人信息相关事宜有任何意见、建议和诉求，请联系我们。我们会随时为您提供服务。
        </p>
      </section>
      <h3>7、修订和更新</h3>
      <section className={styles['panel']}>
        <p>
          1、为给您提供更好的服务以及随着纳米盒业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在纳米盒网站、纳米盒移动端上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问纳米盒以便及时了解最新的隐私政策。
          <br />
          2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。
          本隐私政策所指的重大变更包括但不限于：
        </p>
        <p style={{ textIndent: '2em' }}>
          2.1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
        </p>
        <p style={{ textIndent: '2em' }}>
          2.2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
        </p>
        <p style={{ textIndent: '2em' }}>
          2.3、个人信息共享、转让或公开披露的主要对象发生变化；
        </p>
        <p style={{ textIndent: '2em' }}>
          2.4、您参与个人信息处理方面的权利及其行使方式发生重大变化；
        </p>
        <p style={{ textIndent: '2em' }}>
          2.5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
        </p>
        <p style={{ textIndent: '2em' }}>
          2.6、个人信息安全影响评估报告表明存在高风险时。
        </p>
      </section>
      <h3>8、联系我们</h3>
      <section className={styles['panel']}>
        <p>
          如您对本政策有任何的疑问、建议或投诉，可通过以下方式联系我们，我们将在15日内回复。
          <br />
          开发者信息：上海进馨网络科技有限公司
          <br />
          注册地址：中国(上海)自由贸易试验区盛夏路666号D栋8层
          <br />
          办公地址：中国(上海)自由贸易试验区盛夏路666号D栋8层
          <br />
          联系电话：021-61515671
          <br />
          联系邮箱：privacy@namibox.com
        </p>
      </section>
      <section className={styles['panel']}>
        <p style={{ textAlign: 'center' }}>
          Copyright © 2022
          <br />
          进馨科技 版权所有
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicies;
